import {Component} from 'panel';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';
import css from './index.styl?inline';

const CONTEXT_MENU_DEFAULTS = {
  breakdown: {label: `Expand by property`, icon: `segment`},
  hide: {label: `Hide event`, icon: `eye-hide`},
};

const STATE_RESET = Object.freeze({
  searchFilter: ``,
  secondaryAction: null,
});

export default registerMPElement(
  `mp-context-menu`,
  class ContextMenu extends Component {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        'breakdown-options': {type: `json`, default: {}},
        'menu-items': {type: `json`, default: []},
        open: `boolean`,
        position: {type: `json`, default: {}},
        'project-id': `number`,
        'workspace-id': `number`,
        'source-node': {type: `json`, default: {}},
      };
    }

    get config() {
      return {
        template,
        useShadowDom: true,

        defaultState: {...STATE_RESET},
        helpers: {
          inserted: (vnode) => {
            this.domEl = vnode.elm;
            document.body.style.position = `relative`;
            document.body.appendChild(this.domEl);
          },
          searchInputInserted: (vnode) => {
            this.update({searchInputEl: vnode.elm});
            requestAnimationFrame(() => vnode.elm.focus());
          },
          getCss: () => css.toString(),
          handleBreakdownMenuSelect: (ev) => {
            this.dispatchEvent(
              new CustomEvent(`action`, {
                detail: {
                  action: `breakdown`,
                  value: ev.detail.item,
                },
              }),
            );
            this.reset();
          },
          handleContextMenuSelect: (ev) => {
            switch (ev.detail.item.value) {
              case `breakdown`:
                this.update({secondaryAction: `breakdown`});
                break;
              default:
                this.dispatchEvent(new CustomEvent(`action`, {detail: {action: ev.detail.item.value}}));
                this.reset();
                break;
            }
          },
          handleDropMenuChange: (ev) => {
            if (ev.detail.state === `closed`) {
              this.dispatchEvent(new CustomEvent(`close`));
              this.reset();
            }
          },
          handleSearchInput: (ev) => this.update({searchFilter: ev.target.value}),

          menuItems: () => this.attr(`menu-items`).map((item) => ({...CONTEXT_MENU_DEFAULTS[item.value], ...item})),
          breakdownDisabledItemsMap: () =>
            (this.attr(`breakdown-options`).disabledItems || []).reduce((map, item) => ({...map, [item]: true}), {}),
        },
      };
    }

    disconnectedCallback() {
      if (this.domEl) {
        this.domEl.remove();
      }
    }

    reset() {
      this.update(STATE_RESET);
    }
  },
);
